import { axiosBaseURLAPI } from "./NetworkInstance";
import { AxiosResponse } from "axios";
import { Article, CategoriasInternasAnuncios } from "@/objects/Articles";
import AmazonQueries from "@/network/Amazon";
import { getRandomHeight } from "./Articulos";
import { filtarMoneda } from "./Monedas";
import { noMostrarPorPremium } from "./StringsUtil";
import { baseURLLinks } from "./BaseURL";
import { AmazonResponseCreators } from "@/objects/AmazonCreators";

//export const amazonEbookSearchURL = "https://www.amazon.es/gp/search?ie=UTF8&tag=quierolibrosa-21&linkCode=ur2&linkId=b21688a178ad27cb9916d46900313f0b&camp=3638&creative=24630&index=digital-text&keywords="
export const amazonEbookSearchURL = baseURLLinks + "?slug=amzn_ebook_search&f=1&extra="
export const amazonLeerGratisURL = baseURLLinks + "?slug=audible&f=1"
export const amazonAudibleURL = baseURLLinks + "?slug=kindle_read&f=1"
export const amazonLinkBookURL = baseURLLinks + "?slug=link&f=1&url="
//export const amazonLeerGratisURL = "https://www.amazon.es/kindle-dbs/hz/signup?tag=quierolibrosa-21"

//export const amazonAudibleURL = "https://www.amazon.es/hz/audible/mlp/mdp/discovery?actionCode=AMSTM1450129210001&tag=quierolibrosa-21"

const NUMERO_ARTICULOS_PARA_ANUNCIO = 7;

export async function obtenerArticuloAmazonRandom(): Promise<Article | null> {
    //para premium
    if (noMostrarPorPremium()) {
        return null;
    }
    try {
        const amazonQueries = new AmazonQueries(axiosBaseURLAPI());
        const response: AxiosResponse<AmazonResponseCreators> = await amazonQueries.obtenerLibroAmazonRandom();

        if (response.status !== 200) {
            console.error('Error al obtener artículo de Amazon: Respuesta no exitosa', response);
            return null; // Devuelve null si la respuesta no es exitosa
        }

        if (response.data.searchResult === undefined || response.data.searchResult.items.length === 0) {
            console.warn('No se encontraron resultados en Amazon para el artículo aleatorio');
            return null; // Devuelve null si no se encontraron resultados
        }

        console.log("Respuesta Amazon : ", response.data); // Agrega este log para ver la respuesta completa

        //alert("Respuesta Amazon : " + JSON.stringify(response.data, null, 2)); // Agrega este log para ver la respuesta completa
        const libro = response.data.searchResult.items[0];
        //Si los devuelve sin precio ponemos esto:
        const precioLibro = libro.offersV2?.listings[0]?.price?.money.amount || "";
        const monedaLibro = libro.offersV2?.listings[0]?.price?.money.currency || "";
        const imagen = libro.images.primary.large?.url || libro.images.primary.medium?.url || libro.images.primary.small?.url || "";
        const articleAmazon: Article = {
            id_article: asinToNumber(libro.asin),
            image: imagen,
            linkExtra: amazonLinkBookURL + encodeURIComponent(libro.detailPageURL),
            prize: precioLibro,
            title: libro.itemInfo.title.displayValue,
            moneda: filtarMoneda(monedaLibro),
            isbn: libro.asin,
            articulo_categoria: CategoriasInternasAnuncios.AMAZON,
            post_type: "Amazon",
            sub_type: "Amazon",
            date: new Date().toISOString(),
            destacado: "0",
            verificado: 1,
            vendido: 0,
            mostrar: 1,
            name: "Amazon",
            email: "",
            esTienda: 2,
            avatar: "https://www.amazon.es/favicon.ico",
            distance: 0,
            id_user: 0,
            content: "",
            description: "",
            editorial: "",
            author: "",
            contact_email: "",
            contact_phone: "",
            city: "",
            town: "",
            pais: "",
            tases_shipping: 0,
            coordinates: "",
            estado: "",
            tapa: "",
            whatsapp: 0,
            emailgoogle: "",
            fotogoogle: "",
            namegoogle: "",
            lat: 0,
            lng: 0,
            email_comprador: "",
            id_transaccion: "",
            visto: 0,
            veces_telefono: 0,
            veces_email: 0,
            masonryHeight: getRandomHeight(asinToNumber(libro.asin)),
        };

        return articleAmazon;
    } catch (error) {
        // Maneja el error aquí
        //alert('Error al obtener artículo de Amazon: ' + error)
        console.error('Error al obtener artículo de Amazon:', error);
        return null; // Devuelve null si hay un error
    }
}

export async function addArticuloAmazonToArticles(articles: Article[]): Promise<Article[]> {
    const articleAmazon = await obtenerArticuloAmazonRandom();
    // Si articleAmazon es null, simplemente devuelve los artículos sin agregar el artículo de Amazon
    if (articleAmazon === null) {
        return articles;
    }

    //Cada 7 articulos añade un anuncio de amazon
    const articlesWithAmazon: Article[] = [];
    let count = 0;

    articles.forEach((article, index) => {
        articlesWithAmazon.push(article);
        if ((index + 1) % NUMERO_ARTICULOS_PARA_ANUNCIO === 0 && count === 0) {
            articlesWithAmazon.push(articleAmazon);
            count++;
        }
    });

    return articlesWithAmazon;
}

export async function obtenerArticuloAmazonBusqueda(busqueda: string): Promise<Article | null> {
    //para premium
    if (noMostrarPorPremium()) {
        return null;
    }
    try {
        const amazonQueries = new AmazonQueries(axiosBaseURLAPI());
        const response: AxiosResponse<AmazonResponseCreators> = await amazonQueries.buscarAmazonCreators(busqueda);

        if (response.status !== 200) {
            console.error('Error al obtener artículo de Amazon: Respuesta no exitosa', response);
            return null; // Devuelve null si la respuesta no es exitosa
        }

        if (response.data.searchResult === undefined || response.data.searchResult.items.length === 0) {
            console.warn('No se encontraron resultados en Amazon para la búsqueda:', busqueda);
            return null; // Devuelve null si no se encontraron resultados
        }

        const libro = response.data.searchResult.items[0];
        //alert("Respuesta Libro Amazon : " + JSON.stringify(libro, null, 2)); // Agrega este log para ver la respuesta completa del libro
        const precioLibro = libro.offersV2?.listings[0]?.price?.money.amount || "";
        const monedaLibro = libro.offersV2?.listings[0]?.price?.money.currency || "";
        const imagen = libro.images.primary.large?.url || libro.images.primary.medium?.url || libro.images.primary.small?.url || "";
        const articleAmazon: Article = {
            id_article: asinToNumber(libro.asin),
            image: imagen,
            linkExtra: amazonLinkBookURL + encodeURIComponent(libro.detailPageURL),
            prize: precioLibro,
            title: libro.itemInfo.title.displayValue,
            moneda: filtarMoneda(monedaLibro),
            isbn: libro.asin,
            articulo_categoria: CategoriasInternasAnuncios.AMAZON,
            post_type: "Amazon",
            sub_type: "Amazon",
            date: new Date().toISOString(),
            destacado: "0",
            verificado: 1,
            vendido: 0,
            mostrar: 1,
            name: "Amazon",
            email: "",
            esTienda: 2,
            avatar: "https://www.amazon.es/favicon.ico",
            distance: 0,
            id_user: 0,
            content: "",
            description: "",
            editorial: "",
            author: "",
            contact_email: "",
            contact_phone: "",
            city: "",
            town: "",
            pais: "",
            tases_shipping: 0,
            coordinates: "",
            estado: "",
            tapa: "",
            whatsapp: 0,
            emailgoogle: "",
            fotogoogle: "",
            namegoogle: "",
            lat: 0,
            lng: 0,
            email_comprador: "",
            id_transaccion: "",
            visto: 0,
            veces_telefono: 0,
            veces_email: 0,
            masonryHeight: getRandomHeight(asinToNumber(libro.asin)),
        };

        return articleAmazon;
    } catch (error) {
        // Maneja el error aquí
        console.error('Error al obtener artículo de Amazon:', error);
        return null; // Devuelve null si hay un error
    }
}


function asinToNumber(asin: string): number {
    // Expresión regular para extraer los números del ASIN
    const numbersOnly = asin.match(/\d+/g);
    // Si se encontraron números, los concatenamos en una cadena y los convertimos a un número
    if (numbersOnly) {
        const numericString = numbersOnly.join('');
        return parseInt(numericString, 10);
    }
    // Si no se encontraron números, devolvemos un número aleatorio
    return Math.floor(Math.random() * 10000); // Cambia 10000 al rango que prefieras
}